import { defineMessages } from 'react-intl';

export default defineMessages({
    Annual: {
        id: 'ml.quoteandbind.common.quote-summary-bar.Annual',
        defaultMessage: 'Annual'
    },
    HalfYear: {
        id: 'ml.quoteandbind.common.quote-summary-bar.HalfYear',
        defaultMessage: '6 month'
    },
    termTypeAnnual: {
        id: 'ml.quoteandbind.common.quote-summary-bar.termTypeAnnual',
        defaultMessage: 'Annual policy term'
    },
    termType6Month: {
        id: 'ml.quoteandbind.common.quote-summary-bar.termType6Month',
        defaultMessage: '6 month policy term'
    },
    termType7day: {
        id: 'ml.quoteandbind.common.quote-summary-bar.termType7day',
        defaultMessage: '7 day policy term'
    },
    perTermAnnual: {
        id: 'ml.quoteandbind.common.quote-summary-bar.perTermAnnual',
        defaultMessage: '/year'
    },
    perTerm6Month: {
        id: 'ml.quoteandbind.common.quote-summary-bar.perTerm6Month',
        defaultMessage: '/6 month'
    },
    premium7day: {
        id: 'ml.quoteandbind.common.quote-summary-bar.premium7day',
        defaultMessage: '/7 days'
    },
    non7DaysMonthlyPremium: {
        id: 'ml.quoteandbind.common.quote-summary-bar.non7DaysMonthlyPremium',
        defaultMessage: '/month'
    },
    orLabel: {
        id: 'ml.quoteandbind.common.quote-summary-bar.orLabel',
        defaultMessage: 'OR'
    },
    payFullAmount: {
        id: 'ml.quoteandbind.common.quote-summary-bar.payFullAmount',
        defaultMessage: 'Pay full amount and save'
    },
    change: {
        id: 'ml.quoteandbind.common.quote-summary-bar.change',
        defaultMessage: 'Change'
    },
    discountsDisplay: {
        id: 'ml.quoteandbind.common.quote-summary-bar.discountsDisplay',
        defaultMessage: '{discountsLabel} {discounts}'
    },
    discountsLabel: {
        id: 'ml.quoteandbind.common.quote-summary-bar.discountsLabel',
        defaultMessage: 'Total Discounts'
    },
    callLabel: {
        id: 'ml.quoteandbind.common.quote-summary-bar.callLabel',
        defaultMessage: 'Or call {phoneNum}'
    },
    yourDiscounts: {
        id: 'ml.quoteandbind.common.quote-summary-bar.yourDiscounts',
        defaultMessage: 'Your discounts'
    },
    showAllDiscounts: {
        id: 'ml.quoteandbind.common.quote-summary-bar.showAllDiscounts',
        defaultMessage: 'Show all discounts'
    },
    hideDiscounts: {
        id: 'ml.quoteandbind.common.quote-summary-bar.hideDiscounts',
        defaultMessage: 'Hide discounts'
    },
    purchasePolicy: {
        id: 'ml.quoteandbind.common.quote-summary-bar.purchasePolicy',
        defaultMessage: 'Purchase Policy'
    },
    effective: {
        id: 'ml.quoteandbind.common.quote-summary-bar.effective',
        defaultMessage: 'Effective'
    },
    effectiveDate: {
        id: 'ml.quoteandbind.common.quote-summary-bar.effective Date',
        defaultMessage: 'Effective Date'
    },
    continueBundle: {
        id: 'ml.quoteandbind.common.quote-summary-bar.continueBundle',
        defaultMessage: 'We\'ll continue with your bundle next'
    },
    continueToPurchase: {
        id: 'ml.quoteandbind.common.quote-summary-bar.continueToPurchase',
        defaultMessage: 'Continue to purchase'
    },
    emailQuote: {
        id: 'ml.quoteandbind.common.quote-summary-bar.emailQuote',
        defaultMessage: 'Email Quote'
    },
    printQuote: {
        id: 'ml.quoteandbind.common.quote-summary-bar.printQuote',
        defaultMessage: 'Print Quote'
    },
    requoting: {
        id: 'ml.quoteandbind.common.quote-summary-bar.requoting',
        defaultMessage: 'Requoting'
    },
    pleaseNoteText: {
        id: 'ml.quoteandbind.common.quote-summary-bar.PleaseNote',
        defaultMessage: 'Please Note'
    },
    pleaseNoteTextContent: {
        id: 'ml.quoteandbind.common.quote-summary-bar.WeMayAsk',
        defaultMessage: 'We may ask for supporting documents related to these discounts after you purchase a policy. '
    },
    effectiveDateValidation: {
        id: 'ml.quoteandbind.common.quote-summary-bar.EffectiveDateValidation',
        defaultMessage: 'The coverage start date must be between 1 and 90 days in the future.'
    }
});
